export const about = {
  name: "Anupam Sai Sistla",
  title: "Software Engineer Intern",
  bio: `Hi, I’m Anupam 👋
I'm a senior Computer Science student at the University of Illinois Chicago, graduating in May 2026, and currently looking for New Grad or Internship roles in Software Engineering.

I enjoy building and shipping software that real teams and customers use. I’ve worked across full stack web applications, APIs, authentication flows, CI/CD pipelines, and cloud deployments, using Python, Java, TypeScript, C++, PHP, and SQL, along with React, Spring Boot, Flask, Docker, Jenkins, and AWS, Azure, GCP.

I’m currently interning at Protegrity, and previously worked at IPage Unmanned Services and Zillion Holidays, where I built everything from enterprise Chrome extensions and SaaS platforms to internal tooling, CI pipelines, and computer vision systems.

I’m especially interested in B2B product engineering, full stack development, distributed systems, cloud platforms, and applied machine learning. I like roles where I can own features end to end and collaborate closely with other engineers to ship reliable, production-ready systems.`,
  location: "United States",
  university: "University of Illinois - Chicago",
  major: "Computer Science",
  age: 21,
  email: "sistlaanupam@gmail.com",
  website: "linkedin.com/in/anupamsistla/"
};